import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2
  },
  subtitle: {
    marginTop: theme.spacing.unit
  },
  divider:{
    marginTop: theme.spacing.unit,
  }
})

@inject("commonStore")
@observer
class CompanyCampaign extends Component {
  handleChange = (name, item) => {
    const { updateCompany } = this.props
    const { filters } = item
    updateCompany({companyCampaignName: name, filters})
  }
  makeItemList = () => {
      const { commonStore, companyCampaignName, campaignID } = this.props
      const { network } = commonStore
      const { priceMaps } = network
      const { company: companyMaps} = priceMaps
      const keys = Object.keys(companyMaps)
      const filteredKeys = keys.filter((key) => {
          return companyMaps[key].active === true
      })  
      return filteredKeys.map((key) => {
        const { active, description, discount, inclusions, price } = companyMaps[key]
        return (<FormControlLabel
          key={key}
          control={
            <Checkbox
              disabled={campaignID}
              checked={key === companyCampaignName}
              onChange={this.handleChange(key, companyMaps[key])}
              value={key}
              color="primary"
            />
      }
      label={`$${price / 100} : ${description}`}
    />)
    })  
  }

  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
      <Typography className={classes.subtitle} variant="subheading">Company Leads</Typography>
      <Divider className={classes.divider} />
      {this.makeItemList()} 
      </Paper>
    );
  }
}

CompanyCampaign.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CompanyCampaign);





// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Company/index.js